import { motion } from 'framer-motion'
import { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ActionButtonProps {
  icon: LucideIcon
  label: string
  onClick?: () => void
  variant?: 'default' | 'primary' | 'secondary'
  className?: string
}

export default function ActionButton({ 
  icon: Icon, 
  label, 
  onClick,
  variant = 'default',
  className 
}: ActionButtonProps) {
  const variants = {
    default: 'bg-background-elevated hover:bg-background-hover text-text-primary',
    primary: 'bg-brand hover:bg-brand-dark text-white shadow-glow',
    secondary: 'bg-accent-cyan/10 hover:bg-accent-cyan/20 text-accent-cyan',
  }
  
  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={onClick}
      className={cn(
        "flex flex-col items-center gap-2 p-4 rounded-2xl transition-all duration-200",
        variants[variant],
        className
      )}
    >
      <div className={cn(
        "w-12 h-12 rounded-xl flex items-center justify-center",
        variant === 'default' && 'bg-background',
        variant === 'primary' && 'bg-white/20',
        variant === 'secondary' && 'bg-accent-cyan/20',
      )}>
        <Icon className="w-5 h-5" />
      </div>
      <span className="text-sm font-medium">{label}</span>
    </motion.button>
  )
}